exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.kpi-holder:nth-child(2){margin-top:15px\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/shipper/src/components/dashboard/Kpi.vue"],"names":[],"mappings":";AACA,yBAAyB,eAAe;CACvC","file":"Kpi.vue","sourcesContent":["\n.kpi-holder:nth-child(2){margin-top:15px\n}"],"sourceRoot":""}]);

// exports
